import BaseService from '@/services/BaseService'

class PerfilService extends BaseService {
    constructor(){
        super('/v1/perfis')
    }
}

export default new PerfilService